export default __webpack_public_path__ + "static/media/slap_meme.130fede7.jpg";